export default "__VITE_ASSET__CVVAzMuX__"